module.exports = __webpack_public_path__ + "img/header.7c36bdba.jpg";